import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const KEY = 'rl_block';

/**
 * Mounted once in Layout. Listens for rate-limit signals written by other tabs.
 * When Tab B hits a 429 and writes to localStorage, Tab A (this hook) redirects.
 * The storage event only fires in tabs OTHER than the one that wrote the value.
 */
export function useRateLimitGuard() {
  const navigate = useNavigate();

  useEffect(() => {
    const handle = (e: StorageEvent) => {
      if (e.key !== KEY || !e.newValue) return;
      try {
        const { reason, until } = JSON.parse(e.newValue) as { reason: string; until: number };
        if (until > Date.now()) {
          navigate(`/error?reason=${reason}`, { replace: true });
        }
      } catch {
        // ignore malformed signal
      }
    };
    window.addEventListener('storage', handle);
    return () => window.removeEventListener('storage', handle);
  }, [navigate]);
}
